var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWoman3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 441.868 441.868",
    style: {
      enableBackground: "new 0 0 441.868 441.868"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3923C"
    },
    d: "M237.612,50.661C231.618,25.06,208.656,6,181.229,6c-45.232,0-81.903,36.671-81.903,81.911v173.702 c0,22.085-17.909,39.994-39.994,39.994h-11.07l7.683,5.326c18.746,12.985,41.748,17.805,63.825,13.75l119.842,4.186L237.612,50.661 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M216.392,323.418l-78.27-2.74 c-21.65,3.98-53.96,4.63-72.51-7.81c-0.37-0.23-5.64-2.75-6-3l-7-8h12c33,0,53.06-18.164,53.06-40.25V87.908 c0-3.144,0.177-6.246,0.522-9.297c2.274-20.141,19.502-35.483,39.771-35.562c0.109,0,0.218-0.001,0.327-0.001 c27.43,0,50.39,19.05,56.38,44.66L216.392,323.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M239.613,330.868c-0.069,0-0.14-0.001-0.209-0.003l-119.203-4.164 c-23.449,4.125-48.08-1.266-67.672-14.836l-7.685-5.327c-2.157-1.495-3.092-4.218-2.309-6.722c0.783-2.504,3.103-4.209,5.727-4.209 h11.071c18.744,0,33.994-15.25,33.994-33.994V87.911C93.326,39.437,132.76,0,181.229,0c29.842,0,55.43,20.27,62.225,49.293 c0.102,0.434,0.155,0.878,0.158,1.324l2,274.208c0.012,1.635-0.645,3.205-1.816,4.345 C242.674,330.26,241.172,330.868,239.613,330.868z M119.771,314.683c0.069,0,0.139,0.001,0.209,0.003l113.587,3.967l-1.949-267.26 C225.877,28.166,205.25,12,181.229,12c-41.853,0-75.903,34.054-75.903,75.911v173.702c0,22.598-16.383,41.442-37.895,45.28 c15.608,8.216,33.825,11.09,51.254,7.889C119.044,314.716,119.407,314.683,119.771,314.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5CDEF"
    },
    d: "M279.462,264.838c0.19,0.05,0.39,0.09,0.58,0.14c10.46,2.53,20.19,6.93,28.83,12.81 c23.39,15.92,38.75,42.77,38.75,73.19v84.89h-47.04h-140.96h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 c8.64-5.88,29.22-12.9,29.41-12.95l11.87-7.97"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5CDEF"
    },
    d: "M159.622,311.868v124h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 C156.632,287.988,159.622,299.578,159.622,311.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5CDEF"
    },
    d: "M347.622,350.978v84.89h-47.04v-124c0-12.29,2.99-23.88,8.29-34.08 C332.262,293.708,347.622,320.558,347.622,350.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M355.607,435.868h-12v-78.69c0-25.832-11.669-50.164-32.857-68.515 c-21.43-18.569-49.979-28.795-80.393-28.795c-62.446,0-113.25,43.653-113.25,97.31v78.69h-12v-78.69 c0-60.274,56.187-109.31,125.25-109.31c33.299,0,64.64,11.267,88.25,31.725c23.859,20.665,37,48.218,37,77.585V435.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M306.582,435.868h-12v-124c0-12.816,3.101-25.558,8.966-36.846l10.648,5.533 c-5.053,9.724-7.614,20.259-7.614,31.313V435.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M327.622,421.868c-3.313,0-6-2.687-6-6v-73c0-3.313,2.687-6,6-6s6,2.687,6,6v73 C333.622,419.182,330.936,421.868,327.622,421.868z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M156.272,289.788c-15.21,15.89-24.56,37.45-24.56,61.19 v82.89h-19.12v-82.89c0-30.42,15.35-57.27,38.74-73.19C153.312,281.608,154.972,285.618,156.272,289.788z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M165.622,435.868h-12v-124c0-11.054-2.562-21.59-7.614-31.313l10.648-5.533 c5.866,11.289,8.966,24.03,8.966,36.846V435.868z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M264.587,411.868h-68.96c-23.159,0-42-18.841-42-42h12c0,16.542,13.458,30,30,30h68.96 c16.542,0,30-13.458,30-30h12C306.587,393.027,287.746,411.868,264.587,411.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M264.587,393.868c-3.313,0-6-2.687-6-6s2.687-6,6-6c6.617,0,12-5.383,12-12c0-3.313,2.687-6,6-6 s6,2.687,6,6C288.587,383.102,277.821,393.868,264.587,393.868z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M361.607,441.868H98.837c-3.313,0-6-2.687-6-6s2.687-6,6-6h262.77c3.313,0,6,2.687,6,6 S364.92,441.868,361.607,441.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M393.607,441.868h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6 S396.92,441.868,393.607,441.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M77.607,441.868h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6 S80.921,441.868,77.607,441.868z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD3AE"
    },
    cx: 149.54,
    cy: 153.868,
    r: 27.89
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD3AE"
    },
    cx: 310.675,
    cy: 153.868,
    r: 27.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M149.539,187.758c-18.687,0-33.89-15.203-33.89-33.89s15.203-33.89,33.89-33.89 s33.89,15.203,33.89,33.89S168.226,187.758,149.539,187.758z M149.539,131.978c-12.07,0-21.89,9.82-21.89,21.89 s9.82,21.89,21.89,21.89s21.89-9.82,21.89-21.89S161.61,131.978,149.539,131.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M310.675,187.758c-18.688,0-33.891-15.203-33.891-33.89s15.203-33.89,33.891-33.89 c18.687,0,33.89,15.203,33.89,33.89S329.362,187.758,310.675,187.758z M310.675,131.978c-12.07,0-21.891,9.82-21.891,21.89 s9.82,21.89,21.891,21.89s21.89-9.82,21.89-21.89S322.745,131.978,310.675,131.978z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M279.467,249.838c-14.1,9.49-31.08,15.03-49.36,15.03s-35.26-5.54-49.36-15.03 c-0.19-0.13-0.39-0.26-0.58-0.4c-23.28-15.94-38.56-42.72-38.56-73.07v-22.5v-51.5c0-48.877,39.623-88.5,88.5-88.5l0,0 c48.877,0,88.5,39.623,88.5,88.5v51.5v22.5c0,30.35-15.28,57.13-38.56,73.07C279.857,249.578,279.657,249.708,279.467,249.838z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7774B"
    },
    d: "M230.108,223.878c-4.87,0-9.739-0.513-14.574-1.538c-3.241-0.688-5.312-3.873-4.625-7.115 c0.688-3.242,3.871-5.312,7.115-4.625c8.019,1.702,16.15,1.701,24.167,0c3.246-0.685,6.427,1.383,7.114,4.625 c0.688,3.242-1.383,6.427-4.624,7.115C239.846,223.365,234.977,223.878,230.108,223.878z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M230.613,236.868h-1.011c-2.209,0-4-1.791-4-4s1.791-4,4-4h1.011c2.209,0,4,1.791,4,4 S232.822,236.868,230.613,236.868z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M211.747,249.838c10.02,6.74,21.5,11.49,33.86,13.68 c-5.03,0.89-10.21,1.35-15.5,1.35c-18.28,0-35.26-5.54-49.36-15.03c-0.19-0.13-0.39-0.26-0.58-0.4 c-23.28-15.94-38.56-42.72-38.56-73.07v-22.5c0-139,54.89-137.301,54.89-134.411l-10.384,15.807 c-15.364,23.387-15.305,53.174-0.958,76.231c2.423,3.895,10.151,17.294,10.019,20.366c-0.483,11.29-9.201,21.36-21.338,21.975 c-0.407,0.021-0.817,0.031-1.229,0.031v22.5c0,30.35,15.28,57.13,38.56,73.07C211.357,249.578,211.557,249.708,211.747,249.838z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 195.767,
    cy: 164.984,
    r: 8.009
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M180.438,172.076c-1.533,0-3.065-0.583-4.236-1.751c-2.347-2.339-2.353-6.139-0.013-8.485 c6.152-6.171,15.546-7.748,23.375-3.919c2.977,1.456,4.211,5.048,2.756,8.025c-1.457,2.977-5.049,4.209-8.025,2.756 c-3.218-1.573-7.078-0.926-9.608,1.611C183.515,171.487,181.976,172.076,180.438,172.076z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 264.447,
    cy: 164.984,
    r: 8.009
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M279.777,172.076c-1.538,0-3.077-0.588-4.249-1.764c-2.529-2.537-6.391-3.183-9.608-1.611 c-2.979,1.456-6.57,0.221-8.025-2.756c-1.455-2.977-0.222-6.57,2.756-8.025c7.828-3.826,17.222-2.252,23.376,3.919 c2.34,2.347,2.334,6.146-0.013,8.485C282.842,171.492,281.309,172.076,279.777,172.076z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M223.163,196.868c-3.313,0-6-2.687-6-6v-32.927c0-2.734-1.479-5.177-3.858-6.375 c-7.191-3.622-19.525-7.154-37.44-3.412c-3.24,0.676-6.421-1.403-7.1-4.647c-0.677-3.244,1.403-6.422,4.647-7.1 c21.307-4.448,36.39-0.04,45.289,4.441c6.453,3.249,10.461,9.799,10.461,17.093v32.927 C229.163,194.182,226.477,196.868,223.163,196.868z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3923C"
    },
    d: "M318.612,102.368v39.5c-28.01-18-39-66-39-66s-14,56-138,56h-0.01v-29.5 c0-48.88,39.63-88.5,88.5-88.5h0.01C278.982,13.868,318.612,53.488,318.612,102.368z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M188.612,102.368c0-40.741,27.534-75.044,65-85.339c-7.484-2.057-15.363-3.161-23.5-3.161h-0.01 c-48.87,0-88.5,39.62-88.5,88.5v41.5h0.01c17.856,0,33.419-1.166,47-3.154V102.368z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M230.102,270.868c-18.857,0-37.065-5.541-52.659-16.025c-0.265-0.172-0.526-0.349-0.773-0.532 c-25.717-17.663-41.067-46.79-41.067-77.943v-74c0-52.107,42.392-94.5,94.5-94.5c52.118,0,94.511,42.393,94.511,94.5v74 c0,31.176-15.363,60.318-41.103,77.974c-0.144,0.103-0.292,0.204-0.438,0.302l-0.102,0.068c-0.054,0.039-0.092,0.065-0.147,0.103 C267.22,265.317,248.99,270.868,230.102,270.868z M230.113,19.868c-45.501,0-82.51,37.009-82.51,82.5v74 c0,27.237,13.443,52.702,35.959,68.119c0.1,0.068,0.198,0.14,0.294,0.214l0.162,0.103c0.028,0.019,0.057,0.037,0.084,0.056 c13.616,9.164,29.522,14.008,46,14.008c16.467,0,32.357-4.83,45.958-13.966c0.108-0.076,0.222-0.153,0.337-0.23l0.111-0.075 c0.059-0.043,0.094-0.068,0.154-0.109c22.511-15.413,35.95-40.878,35.95-68.119v-74C312.613,56.877,275.603,19.868,230.113,19.868z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M315.368,146.916c-19.947-12.819-31.646-38.896-37.326-55.289 c-13.002,17.929-47.599,46.241-136.43,46.241v-12c117.952,0,132.051-50.94,132.179-51.455c0.669-2.673,3.07-4.545,5.82-4.545 c0.021,0,0.04,0,0.061,0c2.775,0.027,5.17,1.955,5.789,4.661c0.104,0.453,10.804,45.846,36.396,62.291L315.368,146.916z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M199.473,311.868c-1.435,0-2.853-0.515-3.971-1.501c-0.817-0.722-20.074-17.95-24.714-42.348 c-0.07-0.37-0.105-0.745-0.105-1.121l6.026-0.005l5.869-1.116c2.179,11.455,8.434,21.219,13.531,27.606 c0.833-1.956,1.86-3.896,3.083-5.817c9.401-14.784,27.469-23.829,28.234-24.207c1.676-0.828,3.641-0.828,5.316,0 c0.765,0.378,18.832,9.423,28.234,24.209c1.218,1.913,2.243,3.847,3.073,5.795c5.134-6.442,11.443-16.292,13.574-27.762 l11.799,2.192c-4.556,24.512-23.938,41.847-24.76,42.573c-1.769,1.561-4.286,1.939-6.438,0.969c-2.15-0.97-3.532-3.11-3.532-5.469 c0-3.864-1.292-7.854-3.841-11.858c-5.714-8.985-15.935-15.633-20.763-18.432c-4.832,2.81-15.089,9.49-20.773,18.43 c-2.551,4.008-3.843,7.998-3.843,11.86c0,2.359-1.382,4.499-3.532,5.469C201.149,311.694,200.308,311.868,199.473,311.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M230.082,328.868c-3.313,0-6-2.687-6-6v-54.13c0-3.313,2.687-6,6-6s6,2.687,6,6v54.13 C236.082,326.182,233.396,328.868,230.082,328.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.397,98.869c-2.83,0-5.35-2.011-5.891-4.894c-3.441-18.339-14.714-34.299-30.928-43.786 c-2.86-1.674-3.822-5.349-2.148-8.209c1.673-2.86,5.346-3.822,8.209-2.148c19.216,11.244,32.578,30.171,36.662,51.929 c0.61,3.257-1.534,6.393-4.791,7.004C300.136,98.835,299.764,98.869,299.397,98.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M248.617,43.873c-0.399,0-0.79-0.04-1.18-0.12c-0.38-0.08-0.76-0.19-1.12-0.34s-0.71-0.34-1.04-0.56 c-0.33-0.21-0.63-0.46-0.91-0.74c-1.12-1.12-1.76-2.66-1.76-4.24c0-0.4,0.04-0.79,0.12-1.18c0.08-0.38,0.189-0.76,0.34-1.12 c0.15-0.36,0.34-0.71,0.56-1.04c0.21-0.32,0.46-0.63,0.74-0.91c0.28-0.27,0.58-0.52,0.91-0.74s0.68-0.41,1.04-0.56 c0.36-0.14,0.74-0.26,1.12-0.34c0.77-0.15,1.569-0.15,2.35,0c0.38,0.08,0.76,0.2,1.12,0.34c0.36,0.15,0.71,0.34,1.04,0.56 c0.32,0.22,0.63,0.47,0.91,0.74c0.27,0.28,0.52,0.59,0.74,0.91c0.22,0.33,0.399,0.68,0.56,1.04c0.14,0.36,0.26,0.74,0.34,1.12 c0.08,0.39,0.12,0.78,0.12,1.18c0,1.58-0.649,3.12-1.76,4.24c-0.28,0.28-0.59,0.53-0.91,0.74c-0.33,0.22-0.68,0.41-1.04,0.56 s-0.74,0.26-1.12,0.34C249.398,43.833,249.007,43.873,248.617,43.873z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#F2F2F2",
      enableBackground: "new"
    },
    d: "M183.186,196.041L183.186,196.041 c-17.006,0-30.792-13.786-30.792-30.792v-30.792h30.792c17.006,0,30.792,13.786,30.792,30.792l0,0 C213.978,182.255,200.192,196.041,183.186,196.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6082B2"
    },
    d: "M183.186,202.041c-20.288,0-36.792-16.505-36.792-36.792v-30.792c0-3.313,2.687-6,6-6h30.792 c20.288,0,36.792,16.505,36.792,36.792S203.473,202.041,183.186,202.041z M158.393,140.456v24.792 c0,13.67,11.122,24.792,24.792,24.792s24.792-11.122,24.792-24.792s-11.122-24.792-24.792-24.792H158.393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#F2F2F2",
      enableBackground: "new"
    },
    d: "M277.028,196.041L277.028,196.041 c17.006,0,30.793-13.786,30.793-30.792v-30.792h-30.793c-17.006,0-30.792,13.786-30.792,30.792l0,0 C246.236,182.255,260.022,196.041,277.028,196.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6082B2"
    },
    d: "M277.029,202.041c-20.288,0-36.793-16.505-36.793-36.792c0-20.288,16.505-36.792,36.793-36.792 h30.792c3.313,0,6,2.687,6,6v30.792C313.821,185.536,297.316,202.041,277.029,202.041z M277.029,140.456 c-13.671,0-24.793,11.122-24.793,24.792s11.122,24.792,24.793,24.792c13.67,0,24.792-11.122,24.792-24.792v-24.792H277.029z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 213.978,
    y: 159.248,
    style: {
      fill: "#6082B2"
    },
    width: 32.371,
    height: 12
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M293.613,171.868c-3.313,0-6-2.687-6-6v-16c0-3.313,2.687-6,6-6s6,2.687,6,6v16 C299.613,169.182,296.926,171.868,293.613,171.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M195.608,159.873c-1.58,0-3.12-0.64-4.24-1.76c-0.27-0.28-0.53-0.59-0.74-0.91 c-0.22-0.33-0.41-0.68-0.56-1.04s-0.26-0.74-0.34-1.12c-0.08-0.39-0.12-0.78-0.12-1.17c0-0.4,0.04-0.79,0.12-1.18 c0.08-0.38,0.19-0.76,0.34-1.12s0.34-0.71,0.56-1.04c0.21-0.32,0.47-0.63,0.74-0.91c1.12-1.11,2.66-1.75,4.24-1.75 c1.59,0,3.13,0.64,4.25,1.75c0.27,0.28,0.52,0.59,0.74,0.91c0.22,0.33,0.4,0.68,0.55,1.04c0.15,0.36,0.27,0.74,0.35,1.12 c0.07,0.39,0.11,0.78,0.11,1.18c0,0.39-0.04,0.78-0.11,1.17c-0.08,0.38-0.2,0.76-0.35,1.12c-0.15,0.36-0.33,0.71-0.55,1.04 c-0.22,0.32-0.47,0.63-0.74,0.91C198.738,159.233,197.188,159.873,195.608,159.873z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M190.612,361.868c-3.313,0-6-2.687-6-6v-26c0-3.313,2.687-6,6-6s6,2.687,6,6v26 C196.612,359.182,193.926,361.868,190.612,361.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M203.612,348.868h-26c-3.313,0-6-2.687-6-6s2.687-6,6-6h26c3.313,0,6,2.687,6,6 S206.926,348.868,203.612,348.868z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoman3);
export default __webpack_public_path__ + "static/media/woman3.dab6fd5dabc0f7ea6d70d5eb8ed32b9c.svg";
export { ForwardRef as ReactComponent };